<template>
  <div class="input-group">
    <span class="input-group-text"><font-awesome-icon :icon="['fas', 'print']" /></span>
    <select id="labelPrinter" name="labelPrinter" class="form-select" v-model="selectedPrinterId" required>
      <option v-for="printer in printers" :key="printer.id" :value="printer.id">{{ printer.code }}</option>
    </select>
  </div>
</template>

<script setup lang="ts">

import { onMounted, ref, watch } from "vue";
import { useLabelPrintersStore } from "@/stores";
import LabelPrinter from "@/models/frontend/LabelPrinter";

const labelPrinterStore = useLabelPrintersStore();

const printers = ref<LabelPrinter[]>([])
const selectedPrinterId = ref('') // this is a string, as the select element returns it as string

const emit = defineEmits<{(e: 'printerSelected', printer: LabelPrinter | undefined): void}>();

watch(() => selectedPrinterId.value, async (newPrinterId: string) => {
  const newPrinter = printers.value.find(x => x.id == Number.parseInt(newPrinterId));
  emit('printerSelected', newPrinter);
});

onMounted(async () => {
  printers.value = labelPrinterStore.getAll();
  if (printers.value?.length > 0 && selectedPrinterId.value == '') {
    selectedPrinterId.value = String(printers.value[0]!.id);
  }
});
</script>
